import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "share-facebook";
config.viewBox="0 0 31 31"
config.shape = `
<path fill="var(--fill)" fill-rule="evenodd" d="M21.402 10.603H18.59c-.32 0-.938.353-.938.937v.938h2.813v3.75h-2.813v7.5h-3.75v-7.5H11.09v-3.75h2.812v-1.875c0-1.875 1.875-3.75 4.347-3.75h3.153v3.75zM15.777.29c-8.284 0-15 6.717-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.283-6.716-15-15-15z"/>
`;
let ShareFacebookSVG = new SvgFactory(config);

export default ShareFacebookSVG;